import { put } from 'redux-saga/effects'
import axios from '../../axios-conf'
import uris from '../../uris'
import {
  templateLoadSuccess,
  templateLoadFailure,
  templateSaveSuccess,
  templateSaveFailure,
  redirect,
  addNotification,
  templateDeleteFailure,
  templateDeleteSuccess
} from '../actions'
import { uiConstants } from '../../constants'
import { uiHelper } from '../../helpers'

export function* templateLoadSaga() {
  try {
    const result = yield axios.get(uris.template)
    yield put(templateLoadSuccess(result.data))
  } catch (error) {
    yield put(templateLoadFailure(uiHelper.errorMessage(error)))
  }
}

export function* templateSaveSaga(action) {
  try {
    const body = { ...action.payload }
    let url = uris.template
    let method = 'post'
    if (action.payload.id) {
      url += `/${action.payload.id}`
      method = 'put'
    }
    delete body.id
    const result = yield axios({
      method,
      url,
      data: body
    })
    yield put(templateSaveSuccess(result.data))

    if (!action.payload.id) {
      const [, id] = uiHelper.location()
      yield put(redirect(`/${id}/templates/${result.data._id}`))
    }
    yield put(
      addNotification(
        action.payload.id
          ? uiConstants.messages.template_updated
          : uiConstants.messages.template_created
      )
    )
  } catch (error) {
    yield put(addNotification(uiHelper.errorMessage(error), true))
    yield put(templateSaveFailure(uiHelper.errorMessage(error)))
  }
}

export function* templateDeleteSaga(action) {
  try {
    yield axios.delete(`${uris.template}/${action.payload}`)
    const [, id] = uiHelper.location()
    yield put(redirect(`/${id}/templates`))
    yield put(templateDeleteSuccess(action.payload))
    yield put(addNotification(uiConstants.messages.template_deleted))
  } catch (error) {
    yield put(addNotification(uiHelper.errorMessage(error), true))
    yield put(templateDeleteFailure(uiHelper.errorMessage(error)))
  }
}
